// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"PromotionalBanner_col-md-4__gb5Cg","oPromotionalBanner":"PromotionalBanner_oPromotionalBanner__mnbCe","oContainer":"PromotionalBanner_oContainer__Z6j_N"};